// Use get hook
// Params
// response: The response value
// url: The url we want to fetch from
import axios from 'axios';
import { useState, useEffect } from 'react';

const useGet = (url: string) => {
	const [response, setResponse] = useState(null);
	const [loading, setIsLoading] = useState(true);
	const [error, setIsError] = useState(false);

	useEffect(() => {
		axios
			.get(url)
			.then(res => {
				setIsLoading(false);
				setResponse(res);
			})
			.catch(() => {
				setIsLoading(false);
				setIsError(true);
			});
	}, [url]);

	return { response, loading, error };
};

export default useGet;
